module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "isu-poi-active-white-filled.bd1b5af4.svg";